import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useDashboardStore = defineStore('dashboard', () => {
    const stats = ref(null);
    const pulse = ref(null);
    const platform = ref(null);

    return {
        stats,
        pulse,
        platform,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(useDashboardStore.acceptHMRUpdate);
}
